import React from 'react';
import { FormattedMessage } from 'react-intl';

interface IStudentLoanInterestHelpBannerProps {
    dataTestId: string;
}

const StudentLoanInterestHelpBanner = ({ dataTestId }: IStudentLoanInterestHelpBannerProps) => (
    <div className='usa-alert gi-alert gi-alert__left-accent gi-alert__info'>
        <div className='gi-alert__body'>
            <p className='gi-alert__text' data-testid={dataTestId}>
                <FormattedMessage
                    id='ssap.income_information.summary.student_loan_interest_help.title'
                    tagName='strong'
                />
                <br />
                <FormattedMessage id='ssap.income_information.summary.student_loan_interest_help.body' />
            </p>
        </div>
    </div>
);

export default StudentLoanInterestHelpBanner;
